import type { WebsiteHeaderPhotoSchema_PhotoBackground_v1_1_3 } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_BACKGROUND_v1_1_3: WebsiteHeaderPhotoSchema_PhotoBackground_v1_1_3 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoBackground-v1_1_3.json',
  presentationLayout: 'photoBackground',
  photos: [],
  eventName: undefined,
  colors: undefined,
};
